import { Component, input, output, TemplateRef } from '@angular/core';
import { IVerticalMenuItem } from './vertical-menu-item';

@Component({
	selector: 'nr-vertical-menu',
	standalone: false,
	styleUrls: ['./vertical-menu.component.scss'],
	template: `
		<section class="vertical-menu">
			<ul class="vertical-menu-list">
				@for (item of items(); track $index) {
					<nr-vertical-menu-item
						[item]="item"
						(clicked)="clicked.emit($event)"></nr-vertical-menu-item>
				}
			</ul>
		</section>

		<!-- <section class="box-sommario rounded">
			<ul class="list-group list-anchor">
				@for (item of items; track $index) {
					<li
						class="list-group-item-action"
						tooltipClass="nr-tooltip"
						container="body"
						placement="right"
						[ngbTooltip]="item.title">
						@if (item.iconClass) {
							<i [ngClass]="item.iconClass"></i>
						}
						@if (item.text) {
							<span>{{ item.text }}</span>
						}
						@if (item.children) {
							<i class="fas fa-chevron-right fa-2xs"></i>
							<kendo-popup
								[anchorAlign]="{ horizontal: 'right', vertical: 'top' }"
								[popupAlign]="{ horizontal: 'left', vertical: 'top' }">
								@for (child of item.children; track $index) {
									@if (child.iconClass) {
										<i [ngClass]="child.iconClass"></i>
									}
									@if (child.text) {
										<span class="dropdown-item">{{ child.text }}</span>
									}
								}
							</kendo-popup>
						}
					</li>
				}
			</ul>
		</section> -->

		<!-- <section class="box-sommario rounded">
			<kendo-menu class="list-group list-anchor"
				[vertical]="true"
				size="none"
				[kendoMenuHierarchyBinding]="items"
				childrenField="children"
				style="display:inline-block;">
				<ng-template kendoMenuItemTemplate let-item="item">
					<div class="list-group-item-action">
						@if (item.data.iconClass) {
							<i [ngClass]="item.data.iconClass"></i>
						}
						@if (item.data.text) {
							<span>{{ item.data.text }}</span>
						}
					</div>
				</ng-template>
			</kendo-menu>
		</section> -->
	`,
})
export class VerticalMenuComponent {
	public items = input<IVerticalMenuItem[]>();
	public clicked = output<IVerticalMenuItem>();
}
